module.exports = __webpack_public_path__ + "static/renshi-1434b5c8340d90ca76697d3b51592859.png";